/* eslint-disable no-undef */
// project imports
import services from 'utils/mockAdapter';
// import { fixedFuel } from 'data/e-commerce';
import fixedFuel from 'data/fixedFuel.json';

// ==============================|| MOCK SERVICES ||============================== //

services.onGet('/api/fixedFuel/list').reply(200, { fixedFuel });

services.onPost('/api/fixedFuel/filter').reply((config) => {
  try {
    const { filter } = JSON.parse(config.data);

    if (filter.sort === 'high') {
      fixedFuel.sort((a, b) => Number(b.amount) - Number(a.amount));
    }

    if (filter.sort === 'low') {
      fixedFuel.sort((a, b) => Number(a.amount) - Number(b.amount));
    }

    // if (filter.sort === 'popularity') {
    //   fixedFuel.sort((a, b) => Number(b.popularity) - Number(a.popularity));
    // }

    // if (filter.sort === 'stock') {
    //   fixedFuel.sort((a, b) => Number(b.stock) - Number(a.stock));
    // }

    // if (filter.sort === 'new') {
    //   fixedFuel.sort((a, b) => Number(b.new) - Number(a.new));
    // }

    const results = fixedFuel.filter((fixedFuel) => {
      let searchMatches = true;

      if (filter.search) {
        const properties = ['name', 'fuel', 'unit', 'amount'];
        let containsQuery = false;

        properties.forEach((property) => {
          if (fixedFuel[property] && fixedFuel[property].toString().toLowerCase().includes(filter.search.toString().toLowerCase())) {
            containsQuery = true;
          }
        });

        if (!containsQuery) {
          searchMatches = false;
        }
      }

      // const genderMatches = filter.gender.length > 0 ? filter.gender.some((item) => item === fixedFuel.gender) : true;
      // const categoriesMatches =
      //   filter.categories.length > 0 && filter.categories.some((category) => category !== 'all')
      //     ? filter.categories.some((category) => fixedFuel.categories.some((item) => item === category))
      //     : true;
      // const colorsMatches = filter.colors.length > 0 ? filter.colors.some((color) => fixedFuel.colors.some((item) => item === color)) : true;

      // const minMax = filter.price ? filter.price.split('-') : '';
      // const priceMatches = filter.price ? fixedFuel.amount >= minMax[0] && fixedFuel.amount <= minMax[1] : true;
      // const ratingMatches = filter.rating > 0 ? fixedFuel.rating >= filter.rating : true;

      return searchMatches;
    });

    return [200, results];
  } catch (err) {
    console.error(err);
    return [500, { message: 'Internal server error' }];
  }
});

services.onPost('/api/fixedFuel/details').reply((config) => {
  try {
    const { id } = JSON.parse(config.data);

    let results;
    if (id === 'default') {
      [results] = fixedFuel;
    } else {
      // eslint-disable-next-line
      [results] = fixedFuel?.filter((fixedFuel) => fixedFuel.id === Number(id));
    }

    return [200, results];
  } catch (err) {
    console.error(err);
    return [500, { message: 'Internal server error' }];
  }
});

services.onPost('/api/fixedFuel/related').reply((config) => {
  try {
    const { id } = JSON.parse(config.data);

    const results = fixedFuel.filter((fixedFuel) => fixedFuel.id !== Number(id));

    return [200, results];
  } catch (err) {
    console.error(err);
    return [500, { message: 'Internal server error' }];
  }
});

services.onPost('/api/fixedFuel/list/single').reply((config) => {
  try {
    const result = fixedFuel.find((e) => e.id === Number(config.data));
    return [200, result];
  } catch (err) {
    console.error(err);
    return [500, { message: 'Internal server error' }];
  }
});

services.onPost('/api/fixedFuel/insert').reply((config) => {
  try {
    let list = JSON.parse(config.data);
    list = {
      ...list,
      id: fixedFuel.length + 1
    };
    fixedFuel.push(list);
    return [200, { list }];
  } catch (err) {
    console.error(err);
    return [500, { message: 'Internal server error' }];
  }
});

services.onPost('/api/fixedFuel/update').reply((config) => {
  try {
    const list = JSON.parse(config.data);

    let NewProduct = null;
    _.map(fixedFuel, (_list) => {
      if (_list.id === list.id) {
        _.assign(_list, { ...list });
        NewProduct = _list;
      }
      return _list;
    });

    return [200, { NewProduct }];
  } catch (err) {
    console.error(err);
    return [500, { message: 'Internal server error' }];
  }
});
